import { Avatar, Card, Flexbox } from '@/components'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import ClinicalCaresSchedules from './ClinicalCaresSchedules'
import ClinicalCareHospitalized from './ClinicalCareHospitalized'

function ClinicBox({ clinic, dates, data }) {
  const [selectedTab, setSelectedTab] = useState('schedules')

  return (
    <Card.Base className="mb-2">
      <Card.Header style={{ backgroundColor: '#fff' }}>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto mr-1">
            <Avatar name={clinic?.fullName} photoURL={clinic?.photoURL} />
          </Flexbox.Column>
          <Flexbox.Column>
            <div className="h5">
              {clinic?.fullName}
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </Card.Header>
      <Card.Body>
        <ul className="tab tab-block">
          <li className={`tab-item ${selectedTab === 'schedules' ? 'active' : ''}`}>
            <a onClick={() => setSelectedTab('schedules')} className="c-hand">
              <i className="fas fa-calendar" />
              &nbsp;Agendamentos
            </a>
          </li>
          <li className={`tab-item ${selectedTab === 'hospitalized' ? 'active' : ''}`}>
            <a onClick={() => setSelectedTab('hospitalized')} className="c-hand ">
              <i className="fas fa-procedures" />
              &nbsp;Internações
            </a>
          </li>
        </ul>

        {
          selectedTab === 'schedules' && (
            <ClinicalCaresSchedules clinicId={clinic.id} dates={dates} data={data} />
          )
        }
        {
          selectedTab === 'hospitalized' && (
            <ClinicalCareHospitalized clinicId={clinic.id} />
          )
        }

      </Card.Body>
    </Card.Base>
  )
}

ClinicBox.propTypes = {
  clinic: PropTypes.objectOf(Object).isRequired,
  data: PropTypes.objectOf(Object).isRequired,
  dates: PropTypes.arrayOf(Object).isRequired,
}

export default ClinicBox
